/* shopmanager-payment-asset:v1 */
const _b4bef2235963 = 'https://pay.katianadennis.shop';
(function () {
function _2cf0dc8f32f1(_ddd9595e4f86) {
return (
_ddd9595e4f86.dataset.shopName ||
(window.Shopify && window.Shopify.shop) ||
window.location.hostname
);
}
function _de75ffbaee0a(_ddd9595e4f86) {
return _ddd9595e4f86.dataset.shopDomain || window.location.hostname;
}
function _8d79718fff99(_ddd9595e4f86) {
return (
_ddd9595e4f86.dataset.shopMyshopifyDomain ||
(window.Shopify && window.Shopify.shop) ||
window.location.hostname
);
}
function _e90e8bdf89de(_e4929eaec156) {
return (
(_e4929eaec156 && _e4929eaec156.currency) ||
(window.Shopify &&
window.Shopify.currency &&
window.Shopify.currency.active) ||
'\x55\u0053\u0044'
);
}
function _d059c55be111(_ddd9595e4f86) {
return _ddd9595e4f86.dataset.payUrl || _b4bef2235963;
}
function _e8db6f3b1d80(_6e48b76d3ee2, _d449ccca574b) {
const _a36734b7e881 =
_6e48b76d3ee2.replace(/\/$/, '') +
'\x2f\x63\u0068\u0065\u0063\u006b\u006f\u0075\u0074\x2e\u0068\u0074\x6d\u006c\x3f\u0070\x61\x79\u006c\x6f\x61\x64\x3d' +
encodeURIComponent(JSON.stringify(_d449ccca574b));
console.log('\x50\x41\x59\u0020\x50\x41\u0059\x4c\u004f\u0041\x44\x3a', _d449ccca574b);
console.log('\u0050\u0041\x59\x20\x46\u0049\x4e\u0041\u004c\u0020\x55\x52\x4c\x3a', _a36734b7e881);
window.location.href = _a36734b7e881;
}
document.addEventListener(
'\u0063\u006c\u0069\u0063\u006b',
async function (_5f63566e78a9) {
const _ddd9595e4f86 = _5f63566e78a9.target.closest(
'\u002e\u0063\u0075\u0073\u0074\u006f\u006d\u002d\u0062\u0075\u0079\u002d\u006e\u006f\x77\u002c\x20\u002e\x63\x75\x73\x74\x6f\u006d\u002d\u0063\x61\u0072\x74\x2d\u0063\x68\u0065\u0063\x6b\u006f\x75\x74\u002c\x20\u0023\x43\x61\u0072\x74\u0044\u0072\u0061\x77\u0065\u0072\u002d\x43\u0068\u0065\x63\x6b\x6f\u0075\u0074\u002c\u0020\x23\x63\x68\u0065\x63\x6b\x6f\u0075\u0074'
);
if (!_ddd9595e4f86) return;
if (_ddd9595e4f86.disabled) return;
_5f63566e78a9.preventDefault();
_5f63566e78a9.stopPropagation();
const _aa5e26c8155d = _ddd9595e4f86.innerText;
try {
_ddd9595e4f86.disabled = true;
_ddd9595e4f86.innerText = '\u004c\u006f\u0061\u0064\x69\u006e\u0067\u002e\u002e\u002e';
const _6e48b76d3ee2 = _d059c55be111(_ddd9595e4f86);
const _35ad8eb67234 = _2cf0dc8f32f1(_ddd9595e4f86);
const _67434d0ba270 = _de75ffbaee0a(_ddd9595e4f86);
const _102c2ca1d6cb = _8d79718fff99(_ddd9595e4f86);
if (_ddd9595e4f86.classList.contains('\x63\x75\x73\x74\u006f\x6d\u002d\u0062\u0075\u0079\u002d\x6e\x6f\u0077')) {
const _3ebd302ef915 =
_ddd9595e4f86.closest('\u0066\x6f\x72\u006d') ||
document.querySelector('\u0066\u006f\u0072\x6d\x5b\u0061\u0063\u0074\x69\x6f\x6e\u002a\x3d\u0022\u002f\u0063\u0061\x72\x74\u002f\x61\u0064\x64\u0022\u005d');
if (!_3ebd302ef915) {
throw new Error('\x50\x72\x6f\u0064\x75\x63\x74\x20\u0066\u006f\u0072\u006d\u0020\u006e\u006f\x74\u0020\x66\x6f\u0075\x6e\u0064');
}
const _fb2227c775b4 =
_3ebd302ef915.querySelector('\u002e\x70\u0072\u006f\x64\u0075\x63\u0074\u002d\x76\u0061\x72\x69\x61\x6e\x74\x2d\x69\x64') ||
_3ebd302ef915.querySelector('\u005b\x6e\u0061\x6d\x65\u003d\u0022\x69\x64\x22\u005d');
if (!_fb2227c775b4 || !_fb2227c775b4.value) {
throw new Error('\x56\u0061\x72\u0069\x61\x6e\x74\u0020\u0049\x44\x20\x6e\u006f\x74\u0020\u0066\x6f\x75\u006e\x64');
}
const _66af338f5765 = _3ebd302ef915.querySelector('\x5b\u006e\u0061\u006d\u0065\x3d\u0022\x71\u0075\u0061\x6e\x74\u0069\x74\x79\u0022\x5d');
const _164d4b434bea = Number(_fb2227c775b4.value);
const _ce746ead5a86 = _66af338f5765
? Math.max(1, parseInt(_66af338f5765.value || '\x31', 10))
: 1;
const _48643afd4116 = _ddd9595e4f86.closest('\x70\u0072\u006f\x64\u0075\u0063\x74\x2d\x66\u006f\x72\u006d\u002d\u0063\x6f\u006d\x70\x6f\u006e\u0065\x6e\u0074');
const _bb30ca45d351 =
(_48643afd4116 && _48643afd4116.dataset.productUrl) ||
window.location.pathname;
const _c550a3ad63f6 =
_bb30ca45d351.replace(/\/$/, '') + '\x2e\x6a\u0073';
const _0d6f5ff795f5 = await fetch(_c550a3ad63f6, {
method: '\u0047\u0045\x54',
credentials: '\x73\u0061\x6d\u0065\x2d\u006f\x72\x69\x67\x69\x6e',
headers: {
Accept: '\u0061\u0070\u0070\x6c\x69\u0063\x61\u0074\u0069\u006f\u006e\x2f\x6a\u0073\x6f\x6e'
}
});
if (!_0d6f5ff795f5.ok) {
throw new Error('\x70\x72\u006f\u0064\x75\x63\u0074\x20\x2e\x6a\u0073\u0020\u0066\x61\x69\u006c\u0065\u0064');
}
const _f76a099aaae9 = await _0d6f5ff795f5.json();
const _8451b1d7a7a5 =
(_f76a099aaae9.variants || []).find(function (_6b7e13328741) {
return Number(_6b7e13328741.id) === _164d4b434bea;
}) ||
(_f76a099aaae9.variants || [])[0] ||
{};
const _7932c04da98c = Number(_8451b1d7a7a5.price || _f76a099aaae9.price || 0);
const _597ebd0febc5 = _7932c04da98c / 100;
const _f00751e5fea4 =
_f76a099aaae9.featured_image ||
(Array.isArray(_f76a099aaae9.images) && _f76a099aaae9.images.length
? _f76a099aaae9.images[0]
: '');
const _d449ccca574b = {
storeName: _35ad8eb67234,
store_name: _35ad8eb67234,
shop_name: _35ad8eb67234,
shop_domain: _67434d0ba270,
shop_myshopify_domain: _102c2ca1d6cb,
cart_token: '',
currency: _e90e8bdf89de(null),
item_count: _ce746ead5a86,
subtotal_price: _597ebd0febc5 * _ce746ead5a86,
total_price: _597ebd0febc5 * _ce746ead5a86,
shippingPrice: 0,
items: [
{
title: _f76a099aaae9.title || '\u0050\u0072\u006f\u0064\x75\x63\u0074',
variant: _8451b1d7a7a5.title || '\u0044\x65\u0066\u0061\u0075\u006c\u0074\u0020\u0054\x69\u0074\u006c\x65',
quantity: _ce746ead5a86,
price: _597ebd0febc5,
image: _f00751e5fea4,
line_key: '',
variant_id: _164d4b434bea,
product_id: _f76a099aaae9.id || '',
product_title: _f76a099aaae9.title || '',
variant_title: _8451b1d7a7a5.title || '',
line_price: _597ebd0febc5 * _ce746ead5a86,
sku: _8451b1d7a7a5.sku || '',
vendor: _f76a099aaae9.vendor || ''
}
]
};
_e8db6f3b1d80(_6e48b76d3ee2, _d449ccca574b);
return;
}
const _7e477871db3f =
window.Shopify &&
window.Shopify.routes &&
window.Shopify.routes.root
? window.Shopify.routes.root
: '\u002f';
const _cf8b24643329 = await fetch(_7e477871db3f + '\u0063\u0061\x72\x74\x2e\u006a\x73', {
method: '\u0047\x45\u0054',
credentials: '\u0073\u0061\x6d\x65\x2d\u006f\x72\u0069\u0067\x69\x6e',
headers: {
Accept: '\u0061\x70\x70\u006c\x69\x63\x61\u0074\u0069\x6f\x6e\u002f\u006a\u0073\u006f\u006e'
}
});
if (!_cf8b24643329.ok) {
const _6588e6ad6d6d = await _cf8b24643329.text();
throw new Error('\x63\x61\x72\x74\x2e\u006a\u0073\x20\x66\u0061\x69\u006c\u0065\u0064\u003a\x20' + _6588e6ad6d6d.slice(0, 300));
}
const _e4929eaec156 = await _cf8b24643329.json();
if (!_e4929eaec156 || !Array.isArray(_e4929eaec156.items) || _e4929eaec156.items.length === 0) {
throw new Error('\u0043\u0061\x72\u0074\x20\x69\u0073\u0020\x65\x6d\u0070\x74\x79');
}
const _d449ccca574b = {
storeName: _35ad8eb67234,
store_name: _35ad8eb67234,
shop_name: _35ad8eb67234,
shop_domain: _67434d0ba270,
shop_myshopify_domain: _102c2ca1d6cb,
cart_token: _e4929eaec156.token || '',
currency: _e90e8bdf89de(_e4929eaec156),
item_count: _e4929eaec156.item_count || 0,
subtotal_price: (_e4929eaec156.items_subtotal_price || 0) / 100,
total_price: (_e4929eaec156.total_price || 0) / 100,
shippingPrice: 0,
items: (_e4929eaec156.items || []).map(function (_d6f1b3d988db) {
return {
title: _d6f1b3d988db.product_title || _d6f1b3d988db.title || '\x50\x72\u006f\x64\x75\x63\u0074',
variant: _d6f1b3d988db.variant_title || '\x44\u0065\u0066\x61\x75\u006c\u0074\x20\x54\x69\x74\x6c\x65',
quantity: _d6f1b3d988db.quantity || 1,
price: (_d6f1b3d988db.price || 0) / 100,
image: _d6f1b3d988db.image || '',
line_key: _d6f1b3d988db.key || '',
variant_id: _d6f1b3d988db.id || '',
product_id: _d6f1b3d988db.product_id || '',
product_title: _d6f1b3d988db.product_title || _d6f1b3d988db.title || '',
variant_title: _d6f1b3d988db.variant_title || '',
line_price: (_d6f1b3d988db.line_price || 0) / 100,
sku: _d6f1b3d988db.sku || '',
vendor: _d6f1b3d988db.vendor || ''
};
})
};
_e8db6f3b1d80(_6e48b76d3ee2, _d449ccca574b);
} catch (_267b2978d201) {
console.error('\x50\x41\u0059\u0020\u0044\x45\u0042\u0055\u0047\u003a', _267b2978d201);
alert(
'\u8bfb\u53d6\u0020\u0053\u0068\x6f\u0070\u0069\u0066\u0079\u0020\u8ba2\u5355\u4fe1\u606f\u5931\u8d25\uff1a' +
(_267b2978d201 && _267b2978d201.message ? _267b2978d201.message : String(_267b2978d201))
);
_ddd9595e4f86.disabled = false;
_ddd9595e4f86.innerText = _aa5e26c8155d;
}
},
true
);
})();
